import React from "react";

export const NoDiscontinuedPlansSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
    >
      <path
        d="M64.6673 58.3333V23.3333C64.6673 21.7862 64.0527 20.3025 62.9588 19.2085C61.8648 18.1146 60.3811 17.5 58.834 17.5H35.7048C34.744 17.495 33.7993 17.2528 32.9547 16.7949C32.11 16.3369 31.3916 15.6774 30.8631 14.875L28.4715 11.375C27.9431 10.5726 27.2246 9.91307 26.3799 9.45513C25.5353 8.99719 24.5906 8.75497 23.6298 8.75H12.1673C10.6202 8.75 9.13649 9.36458 8.04253 10.4585C6.94857 11.5525 6.33398 13.0362 6.33398 14.5833V52.5C6.33398 55.7083 8.95898 58.3333 12.1673 58.3333H29.6673"
        stroke="black"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.1673 61.2502C50.389 61.2502 53.0007 58.6385 53.0007 55.4168C53.0007 52.1952 50.389 49.5835 47.1673 49.5835C43.9457 49.5835 41.334 52.1952 41.334 55.4168C41.334 58.6385 43.9457 61.2502 47.1673 61.2502Z"
        stroke="black"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.166 32.0832V29.1665"
        stroke="black"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.166 49.5833V43.75"
        stroke="black"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
